/* eslint-disable react/jsx-no-target-blank */
import React, {useMemo} from 'react'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const {privilege} = useAuth()
  const routes = [
    {
      to: '/apps/admin',
      title: 'Adminstration',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/finance/fin001.svg',
      children: [
        {
          to: '/apps/admin/school',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'School',
          model: 'school',
        },
        {
          to: '/apps/admin/academic-year',
          title: 'Academic Year',
          icon: '/media/icons/duotune/general/gen022.svg',
          model: 'academic-year',
        },
        {
          to: '/apps/admin/role',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Role',
          model: 'role',
        },
        {
          to: '/apps/admin/permission',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Permission',
          model: 'permission',
        },
        {
          to: '/apps/admin/account',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Account',
          model: 'account',
        },
      ],
    },
    {
      to: '/apps/employee-management',
      title: 'Employee Management',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/communication/com014.svg',
      children: [
        {
          to: '/apps/employee-management/employee',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Employee',
          model: 'employee',
        },
        {
          to: '/apps/employee-management/employee-attendance',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Employee Attendance',
          model: 'employee-attendance',
        },
        {
          to: '/apps/employee-management/department',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Department',
          model: 'department',
        },
        {
          to: '/apps/employee-management/designation',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Designation',
          model: 'designation',
        },
      ],
    },
    {
      to: '/apps/student-management',
      title: 'Student Management',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/communication/com006.svg',
      children: [
        {
          to: '/apps/student-management/student',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Student',
          model: 'student',
        },
        {
          to: '/apps/student-management/student-attendance',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Student Attendance',
          model: 'student-attendance',
        },
        {
          to: '/apps/student-management/student-type',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Student Type',
          model: 'student-type',
        },
        {
          to: '/apps/student-management/admission',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Online Admission',
          model: 'admission',
        },
      ],
    },
    {
      to: '/apps/academic',
      title: 'Academic',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/finance/fin006.svg',
      children: [
        {
          to: '/apps/academic/class',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Classes',
          model: 'class',
        },
        {
          to: '/apps/academic/section',
          title: 'Section',
          icon: '/media/icons/duotune/general/gen022.svg',
          model: 'section',
        },
        {
          to: '/apps/academic/subject',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Subject',
          model: 'subject',
        },
        {
          to: '/apps/academic/syllabus',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Syllabus',
          model: 'syllabus',
        },
        {
          to: '/apps/academic/routine',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Routine',
          model: 'routine',
        },
        // {
        //   to: '/apps/academic/study-material',
        //   icon: '/media/icons/duotune/general/gen022.svg',
        //   title: 'Study material',
        //   model: 'study-material',
        // },
        {
          to: '/apps/academic/class-lecture',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Class Lecture',
          model: 'class-lecture',
        },
        {
          to: '/apps/academic/assignment',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Assignment',
          model: 'assignment',
        },
        {
          to: '/apps/academic/assignment-submission',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Assignment Submission',
          model: 'assignment-submission',
        },
      ],
    },
    {
      to: '/apps/id-cards',
      title: 'ID Card',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/technology/teh002.svg',
      children: [
        {
          to: '/apps/id-cards/student-id-card',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Student ID Card',
          model: 'student-id-card',
        },
        {
          to: '/apps/id-cards/employee-id-card',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Employee ID Card',
          model: 'employee-id-card',
        },
      ],
    },
    {
      to: '/apps/exam',
      title: 'Exam',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/general/gen055.svg',
      children: [
        {
          to: '/apps/exam/exam-term',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Exam Term',
          model: 'exam-term',
        },
        {
          to: '/apps/exam-schedule',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Schedule',
          model: 'exam-schedule',
        },
        {
          to: '/apps/exam/grade',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Grade',
          model: 'grade',
        },
        {
          to: '/apps/exam/exam-attendance',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Attendance',
          model: 'exam-attendance',
        },
      ],
    },
    {
      to: '/apps/exam-taken-exam',
      title: 'Online Exam',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/general/gen055.svg',
      children: [
        {
          to: '/apps/exam/exam-instruction',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Exam Instructions',
          model: 'exam-instruction',
        },
        {
          to: '/apps/exam/exam-question',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Question Bank',
          model: 'exam-question',
        },
        {
          to: '/apps/exam/exam-online-exam',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Online Exam',
          model: 'exam-online-exam',
        },
        {
          to: '/apps/exam/exam-taken-exam',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Exam Result',
          model: 'exam-taken-exam',
        },
      ],
    },
    {
      to: '/apps/mark',
      title: 'Exam Mark',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/ecommerce/ecm011.svg',
      children: [
        {
          to: '/apps/mark',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Mark',
          model: 'mark',
        },
        {
          to: '/apps/marksheet',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Marksheet',
          model: 'marksheet',
        },
        {
          to: '/apps/broadsheet',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Broadsheet',
          model: 'broadsheet',
        },
        {
          to: '/apps/psychomotor',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Psychomotor',
          model: 'psychomotor',
        },
        {
          to: '/apps/exam-result',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Exam Term Result',
          model: 'exam-result',
        },
        {
          to: '/apps/result-card',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Result Card',
          model: 'result-card',
        },
      ],
    },
    {
      to: '/apps/promotion',
      icon: '/media/icons/duotune/arrows/arr056.svg',
      title: 'Promotion',
      fontIcon: 'bi-app-indicator',
      model: 'promotion',
    },
    {
      to: '/apps/asset-item',
      title: 'Asset Management',
      icon: '/media/icons/duotune/general/gen019.svg',
      children: [
        {
          to: '/apps/asset-category',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Asset Categories',
          fontIcon: 'bi-layers',
          model: 'asset-category',
        },
        {
          to: '/apps/store',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Asset Store',
          fontIcon: 'bi-layers',
          model: 'store',
        },
        {
          to: '/apps/asset-item',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Asset Items',
          fontIcon: 'bi-layers',
          model: 'asset-item',
        },
        {
          to: '/apps/asset-purchase',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Asset Purchase',
          fontIcon: 'bi-layers',
          model: 'asset-purchase',
        },
        {
          to: '/apps/asset-issue',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Asset Issued',
          fontIcon: 'bi-layers',
          model: 'asset-issue',
        },
      ],
    },
    {
      to: '/apps/leave',
      title: 'Leave',
      icon: '/media/icons/duotune/general/gen009.svg',
      children: [
        {
          to: '/apps/leave-application',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Leave Application',
          fontIcon: 'bi-layers',
          model: 'leave-application',
        },
        {
          to: '/apps/leave-type',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Leave Type',
          fontIcon: 'bi-layers',
          model: 'leave-type',
        },
      ],
    },
    {
      to: '/apps/library-member',
      title: 'Library',
      icon: '/media/icons/duotune/files/fil002.svg',
      children: [
        {
          to: '/apps/book',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Books',
          fontIcon: 'bi-layers',
          model: 'book',
        },
        {
          to: '/apps/book-issue',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Issue & Return',
          fontIcon: 'bi-layers',
          model: 'book-issue',
        },
      ],
    },
    {
      to: '/apps/hostel',
      title: 'Hostel',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/ecommerce/ecm004.svg',
      children: [
        {
          to: '/apps/hostel',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Hostel',
          fontIcon: 'bi-layers',
          model: 'hostel',
        },
        {
          to: '/apps/room',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Rooms',
          fontIcon: 'bi-layers',
          model: 'room',
        },
        {
          to: '/apps/hostel-member',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Hostel Member',
          fontIcon: 'bi-layers',
          model: 'hostel-member',
        },
      ],
    },
    //DISCOUNT
    {
      to: '/apps/discount',
      title: 'Accounting',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/finance/fin001.svg',
      children: [
        {
          to: '/apps/discount',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Discount',
          fontIcon: 'bi-layers',
          model: 'discount',
        },
        {
          to: '/apps/fee-type',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Fee Type',
          fontIcon: 'bi-layers',
          model: 'fee-type',
        },
        {
          to: '/apps/invoice',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Invoice',
          fontIcon: 'bi-layers',
          model: 'invoice',
        },
        {
          to: '/apps/payment',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Payment Transaction',
          fontIcon: 'bi-layers',
          model: 'payment',
        },
        {
          to: '/apps/expenditure',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Expenditure',
          fontIcon: 'bi-layers',
          model: 'expenditure',
        },
        {
          to: '/apps/expenditure/exphead',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Expenditure Head',
          fontIcon: 'bi-layers',
          model: 'exphead',
        },
      ],
    },
    {
      to: '/apps/scholarship',
      title: 'Scholarship',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/files/fil009.svg',
      children: [
        {
          to: '/apps/donor',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Donor',
          fontIcon: 'bi-layers',
          model: 'donor',
        },
        {
          to: '/apps/donation',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Donation',
          fontIcon: 'bi-layers',
          model: 'donation',
        },
        {
          to: '/apps/candidate',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Candidate',
          fontIcon: 'bi-layers',
          model: 'candidate',
        },
        {
          to: '/apps/scholarship',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Scholaship',
          fontIcon: 'bi-layers',
          model: 'scholarship',
        },
      ],
    },
    {
      to: '/apps/transportation',
      title: 'Transportation ',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/ecommerce/ecm006.svg',
      children: [
        {
          to: '/apps/vehicle',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Vehicles',
          fontIcon: 'bi-layers',
          model: 'scholarship',
        },
        {
          to: '/apps/route',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Transport Route',
          fontIcon: 'bi-layers',
          model: 'route',
        },
        {
          to: '/apps/route-stop',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Route Stop',
          fontIcon: 'bi-bus',
          model: 'route-stop',
        },
        {
          to: '/apps/transport-member',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Transport Member',
          fontIcon: 'bi-layers',
          model: 'transport-member',
        },
      ],
    },
    {
      to: '/apps/Complains',
      title: 'Complain',
      icon: '/media/icons/duotune/communication/com007.svg',
      children: [
        {
          to: '/apps/complain/type',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Complain Type',
          fontIcon: 'bi-layers',
          model: 'complain-type',
        },
        {
          to: '/apps/complain',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Complains',
          fontIcon: 'bi-layers',
          model: 'complain',
        },
      ],
    },
    {
      to: '/apps/frontdest',
      title: 'Front Desk',
      fontIcon: 'bi-office',
      icon: '/media/icons/duotune/communication/com008.svg',
      children: [
        {
          to: '/apps/purpose',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Visit Purpose',
          fontIcon: 'bi-layers',
          model: 'purpose',
        },
        {
          to: '/apps/visitor',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Visitor',
          fontIcon: 'bi-layers',
          model: 'visitor',
        },

        // {
        //   to: '/apps/dispatch',
        //   icon: '/media/icons/duotune/general/gen022.svg',
        //   title: 'Postal Dispatch',
        //   fontIcon: 'bi-layers',
        //   model: 'dispatch',
        // },
        // {
        //   to: '/apps/receive',
        //   icon: '/media/icons/duotune/general/gen022.svg',
        //   title: 'Postal Receive',
        //   fontIcon: 'bi-layers',
        //   model: 'receive',
        // },
        // {
        //   to: '/apps/calllog',
        //   icon: '/media/icons/duotune/general/gen022.svg',
        //   title: 'Call Logs',
        //   fontIcon: 'bi-layers',
        //   model: 'calllog',
        // },
      ],
    },
    {
      to: '/apps/incident',
      title: 'Disciplinary Records',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/files/fil015.svg',
      children: [
        {
          to: '/apps/incident',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Incident',
          fontIcon: 'bi-layers',
          model: 'incident',
        },
        {
          to: '/apps/incident-category',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Incident Category',
          fontIcon: 'bi-layers',
          model: 'incident-category',
        },
      ],
    },
    {
      to: '/apps/frontend',
      title: 'Manage Frontend',
      fontIcon: 'bi-chat-left',
      icon: '/media/icons/duotune/general/gen001.svg',
      children: [
        {
          to: '/apps/frontend/slider',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Slider',
          model: 'slider',
        },
        {
          to: '/apps/frontend/news',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Announcement',
          model: 'news',
        },
        {
          to: '/apps/gallery',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Gallery',
          model: 'gallery',
        },
      ],
    },
    {
      to: '/apps/settings',
      title: 'Setting',
      fontIcon: 'bi-setting',
      icon: '/media/icons/duotune/coding/cod001.svg',
      children: [
        {
          to: '/apps/settings/admission-field',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Admission Field',
          model: 'admission-field',
        },
        {
          to: '/apps/settings/payment-setting',
          icon: '/media/icons/duotune/general/gen022.svg',
          title: 'Payment Settings',
          model: 'payment-setting',
        },
      ],
    },
  ]
  const allowedRoutes = useMemo(() => {
    const data: any = []
    routes.forEach((route: any) => {
      if (route.model) {
        const model = route.model
        if (model && !privilege?.find((p) => p.operation?.operation_slug === model)?.is_view) return
      }
      if (!route.children) {
        data.push(route)
        return
      }
      const allowedChildren = route.children.filter((child: any) => {
        const model = child.model
        if (model) {
          return privilege?.find((p) => p.operation?.operation_slug === model)?.is_view
        }
        return true
      })
      if (allowedChildren.length > 0) {
        data.push({
          ...route,
          children: allowedChildren,
        })
      }
    })
    return data
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [privilege])
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/general/gen008.svg'
        title='Dashboard'
        fontIcon='bi-app-indicator'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Modules</span>
        </div>
      </div>
      {allowedRoutes.map((route: any, index: number) => {
        if (route.children) {
          return (
            <AsideMenuItemWithSub
              key={index}
              to={route.to}
              title={route.title}
              fontIcon={route.fontIcon}
              icon={route.icon}
            >
              {route.children.map((child: any, idx: number) => (
                <AsideMenuItem key={idx} to={child.to} icon={child.icon} title={child.title} />
              ))}
            </AsideMenuItemWithSub>
          )
        }
        return <AsideMenuItem key={index} to={route.to} icon={route.icon} title={route.title} />
      })}
    </>
  )
}
